export default {
  label: {
    importResume: 'Import Resume',
    uploadResume: 'Upload Resume',
    import: 'Import',
    signInWith: 'Import Resume From',
    thirdPartyAccount: 'Email/Mobile',
    thirdPartyPassword: 'Password',
    resumeName: 'Resume Name',
    resumeCnName: '(Chinese)',
    resumeEnName: '(English)',
    job51Channel: '51job.com',
    jobStreetChannel: 'Jobstreet.com',
    resume: 'Resume'
  },
  btn: {
    signIn: 'Sign In',
    cancel: 'Cancel',
    import: 'Import',
    skip: 'Skip'
  },
  placeholder: {
    account: 'Please input email/mobile',
    password: 'Please input password',
    platform: 'Please select platform',
    resume: 'Please select your resume'
  },
  message: {
    needVerifyCode: 'Please input captcha!',
    thirdPartyLoginError: 'Login failed, please try again later!',
    UserNameOrPwdError: 'Your username or password is incorrect!',
    UserMobileRequired: 'Phone number is required!',
    loginErrToManyTimes: 'Please try again later!',
    tryLater: 'Please try later!',
    loadResumeFailed: 'Load resume failed!',
    confirmationAccount: 'Phone number or email does not exist, please reenter after confirmation!',
    needPhoneBinding: 'You need to bind your phone to this account in the officical website of zhaopin!',
    inputAccountFormatError: 'The format of mobile or email is not correct!',
    passwordShort: 'Password is too short!',
    needFetchSMSCode: 'Please input sms code!',
    smsCodeError: 'SMS code is incorrect!',
    praseFailure: 'Parsing failed, please select another resume!',
    loginExpiration: 'Login timed out, please log in again!',
    loadResumeFailedLater: 'Load resume failed, please try again later!'
  }
}
